import { Clock, Mail, MapPin } from "lucide-react";
import { useLang } from "@/i18n";
import { ContactForm } from "./ContactForm";
import { Eyebrow, Reveal } from "./Reveal";

export const Contact = () => {
  const { t } = useLang();

  return (
    <section id="contact" data-testid="contact-section" className="bg-[#F3EFE6] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-16 lg:grid-cols-2 lg:gap-20">
          <Reveal>
            <Eyebrow>{t.contact.eyebrow}</Eyebrow>
            <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.15] tracking-tight text-[#0A1F18] sm:text-4xl lg:text-5xl">
              {t.contact.title}
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-[#5C6B64]">{t.contact.sub}</p>

            <div className="mt-12 space-y-6">
              {[
                { icon: MapPin, label: t.contact.addressLabel, value: t.contact.address, testid: "contact-info-address" },
                { icon: Mail, label: t.contact.emailLabel, value: "contact@columbusmanagementconsulting.com", testid: "contact-info-email" },
              ].map((row) => (
                <div key={row.label} className="flex items-start gap-4" data-testid={row.testid}>
                  <span className="mt-0.5 flex h-9 w-9 items-center justify-center border border-[#E4DDD0] bg-white text-[#B36C45]">
                    <row.icon className="h-4 w-4" />
                  </span>
                  <div>
                    <span className="block font-mono text-[10px] uppercase tracking-[0.25em] text-[#5C6B64]">
                      {row.label}
                    </span>
                    <span className="mt-1 block text-sm text-[#0A1F18]">{row.value}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 inline-flex items-center gap-3 border border-[#C87D55]/40 bg-[#C87D55]/10 px-4 py-3">
              <Clock className="h-4 w-4 text-[#B36C45]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#B36C45]">
                {t.contact.response}
              </span>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <ContactForm testidPrefix="contact-form" />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
